import { render, staticRenderFns } from "./assist-manage-collecting.vue?vue&type=template&id=6948b302&scoped=true"
import script from "./assist-manage-collecting.vue?vue&type=script&lang=ts"
export * from "./assist-manage-collecting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6948b302",
  null
  
)

export default component.exports